import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const CalendarIcon = ({ width = 20, height = 20, fill = '#52575C' }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.166 1.667a.833.833 0 1 0-1.667 0v.834h-5v-.834a.833.833 0 0 0-1.666 0v.834H4.166a2.5 2.5 0 0 0-2.5 2.5v11.667a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5V5a2.5 2.5 0 0 0-2.5-2.5h-1.667v-.834zm2.5 5.834V5a.833.833 0 0 0-.833-.833h-1.667V5A.833.833 0 1 1 12.5 5v-.833h-5V5a.833.833 0 0 1-1.666 0v-.833H4.166A.833.833 0 0 0 3.333 5v2.5h13.333zM3.333 9.168h13.333v7.5c0 .46-.373.833-.833.833H4.166a.833.833 0 0 1-.833-.834v-7.5z"
      fill={fill}
    />
  </svg>
);
